module.exports = __webpack_public_path__ + "static/media/07-baby.b8ebb487.png";